<mat-card class="general-card">
    <mat-card-content class="general-card__content">
        <ng-content></ng-content>
    </mat-card-content>
</mat-card>
